import React from "react";
import styled from "styled-components";
import Spinner from "../../../components/Spinner";
import { primaryColor } from "../../../constants/colors";

const AvailableSlots = ({ bookedAppoinments, fetching, slots, selectedSlot, onSlotSelect }) => {
  function formatTime(input) {
    const timeString = input.toString().padStart(4, "0");
    const hours24 = parseInt(timeString.slice(0, 2), 10);
    const minutes = timeString.slice(2);
    const period = hours24 >= 12 ? "PM" : "AM";
    const hours12 = hours24 % 12 || 12;
    return `${hours12.toString().padStart(2, "0")}:${minutes} ${period}`;
  }

  return (
    <Wrapper className="px-3 py-2 mt-2">
      <p className="txt">Select Time</p>
      {fetching ? (
        <Spinner />
      ) : (
        <div className="d-flex gap-2 align-items-center slotWrapper">
          {slots.length === 0 && (
            <p className="txt mx-auto fw-bold" style={{ fontSize: 12 }}>
              No Slot Available.
            </p>
          )}
          {slots.length > 0 &&
            slots.map((slot, i) => {
              const bookedSlotsOfThisTime = bookedAppoinments.filter((appoint) => appoint.time === slot.time);
              const remainingSlots = slot.booking_limit - bookedSlotsOfThisTime.length;

              return (
                <div key={i} className="d-flex flex-column">
                  <div
                    onClick={() => {
                      if (remainingSlots > 0) {
                        onSlotSelect(slot);
                      }
                    }}
                    className={`slot-item text-black fw-medium rounded max-content d-flex py-2 px-3 ${remainingSlots == 0 ? "disabled" : ""} ${selectedSlot?.time === slot?.time ? "active" : ""}`}
                  >
                    <span>{`${formatTime(slot.time)}`}</span>
                  </div>
                  {<span className={`text-center text-green ${remainingSlots == 0 ? "disabled" : ""}`}>{`${remainingSlots == 0 ? "Not Available" : `${remainingSlots} Slot${remainingSlots == 1 ? "" : "s"} Available`} `}</span>}
                </div>
              );
            })}
        </div>
      )}
    </Wrapper>
  );
};

export default AvailableSlots;

const Wrapper = styled.div`
  .slotWrapper {
    overflow-x: scroll;
  }
  .slot-item {
    background-color: #e9e9e9;
    white-space: nowrap;
    cursor: pointer;
    &.disabled {
      background-color: #f3f3f3;
      span {
        color: #b6b6b6;
      }
    }
    &.active {
      background-color: ${primaryColor};
      span {
        color: #fff;
      }
    }
  }
  .slotWrapper::-webkit-scrollbar {
    display: none;
  }
  .txt {
    color: #9e9e9e;
  }
  .text-green {
    color: #00c033;
    font-size: 0.7rem;
    &.disabled {
      color: #b6b6b6;
    }
  }
  p {
    margin-bottom: 0.4rem;
  }
`;
